import React, { useEffect, useState } from 'react';
import { api, endpoint } from '../../api';
import Chart from 'react-apexcharts';

const DialChart = ({ data, isLoading = false, setIsLoading }) => {
  const { chartTitle, locations } = data;
  const [dial, setDial] = useState({});

  const getDial = async () => {
    const { result, success } = await api.get(endpoint.dial, {
      params: {
        yAxis: locations[0].yAxis,
      },
    });
    if (success) {
      setDial(result);
    }
  };

  useEffect(() => {
    getDial();
  }, []);

  var options = {
    series: [Number(dial?.value)],
    options: {
      chart: {
        type: 'radialBar',
        offsetY: -20,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: '#e7e7e7',
            strokeWidth: '90%',
            margin: 5, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              color: '#999',
              opacity: 1,
              blur: 2,
            },
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: -2,
              fontSize: '22px',
              formatter: function (val) {
                return val.toFixed(2);
                // return parseInt(val);
              },
            },
          },
        },
      },
      grid: {
        padding: {
          top: -10,
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'as',
          shadeIntensity: 0.4,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 25, 50, 53, 91],
        },
      },
      labels: ['Average Results'],
    },
  };

  return (
    <div className="p-3">
      {dial && Object.keys(dial).length > 0 ? (
        <>
          <h4 className="text-center mb-3 fw-bold mb-0 text-capitalize"> {chartTitle} </h4>
          <Chart options={options.options} series={options.series} type="radialBar" />
        </>
      ) : (
        'No Data Found'
      )}
    </div>
  );
};

export default DialChart;
